import 'owl.carousel';

(function ($) {
  const navPrev = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>';
  const navNext = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>';

  /**
   * Initialize all sliders inside `root` (defaults to the whole document).
   * Runs on DOM ready for the front end and is re-invoked per block preview
   * in the editor (editor-preview.js), so every selector is guarded with
   * [data-slider-init] against double initialization.
   */
  function initSliders(root) {
    const $scope = $(root || document);
    const fresh = (selector) =>
      $scope.find(selector).not('[data-slider-init]').attr('data-slider-init', '1');

    // Hero slider — fade transition, matches the flatsome [ux_slider type="fade"]
    fresh('.phent-hero-slider').each(function () {
      const $slider = $(this);

      // The first slide renders statically before init (no entrance animation);
      // once the carousel moves on, let slide 1 animate like the others.
      // `translate` (not `changed`) — owl fires `changed` during its own init.
      $slider.one('translate.owl.carousel', function () {
        $slider.find('.slide-anim--static').removeClass('slide-anim--static');
      });

      $slider.owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: parseInt($slider.data('autoplay'), 10) || 10000,
        autoplayHoverPause: false,
        animateOut: 'fadeOut',
        smartSpeed: 800,
        dots: true,
        nav: false,
      });
    });

    // Banner two columns — split-screen banner slider: one carousel, slides
    // cross-FADE (fadeOut like the hero) while the text content fades in/out
    // via CSS on .owl-item.active. Clickable progress-bar dots; optional
    // autoplay (data-autoplay=0 disables it).
    fresh('.phent-banner2__carousel').each(function () {
      const $slider  = $(this);
      const autoplay = parseInt($slider.data('autoplay'), 10) || 0;

      // Dot bars flip to dark when the active slide has the cream panel.
      const syncScheme = () => {
        const scheme = $slider.find('.owl-item.active .phent-banner2__slide').data('scheme') || 'primary';
        $slider.attr('data-active-scheme', scheme);
      };

      $slider.on('initialized.owl.carousel changed.owl.carousel', () => setTimeout(syncScheme));

      $slider.owlCarousel({
        items: 1,
        loop: true,
        autoplay: autoplay > 0,
        autoplayTimeout: autoplay || 7000,
        autoplayHoverPause: true,
        animateOut: 'fadeOut',
        smartSpeed: 900,
        dots: true,
        nav: false,
      });
    });

    // Header USP ticker (style 2) — continuous linear scroll, souman-agro-style.
    // Owl's autoplay plugin proved unreliable here (never fires its first
    // tick with autoWidth), so the crawl is driven directly: every finished
    // 9s linear transition immediately queues the next slide.
    fresh('.header-usp-slider').each(function () {
      const $slider = $(this);

      $slider.owlCarousel({
        loop: true,
        autoplay: false,
        smartSpeed: 9000,
        slideTransition: 'linear',
        nav: false,
        dots: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        margin: 48,
        // Natural item widths — phent's USP sentences are longer than a
        // fixed 3-column grid allows.
        autoWidth: true,
        items: 3,
      });

      const crawl = () => $slider.trigger('next.owl.carousel', [9000]);

      $slider.on('translated.owl.carousel', crawl);
      setTimeout(crawl, 1500);
    });

    // Topbar USP fader (header style 3) — one USP visible at a time,
    // cross-fading in place (stacked absolute items, CSS opacity transition).
    fresh('.topbar-usp-fader').each(function () {
      const $items = $(this).find('.topbar-usp-fader__item');

      if ($items.length < 2) {
        return;
      }

      const interval = parseInt($(this).data('interval'), 10) || 4500;
      let current = 0;

      setInterval(() => {
        $items.eq(current).removeClass('is-active');
        current = (current + 1) % $items.length;
        $items.eq(current).addClass('is-active');
      }, interval);
    });

    // Reviews slider — soul-flower-style testimonial cards, 3 columns
    // desktop / 2 tablet / 1 mobile, nav arrows, optional autoplay
    // (data-autoplay=0 disables it).
    fresh('.phent-reviews-slider').each(function () {
      const $slider = $(this);
      const autoplay = parseInt($slider.data('autoplay'), 10) || 0;

      $slider.owlCarousel({
        loop: true,
        autoplay: autoplay > 0,
        autoplayTimeout: autoplay || 7000,
        autoplayHoverPause: true,
        smartSpeed: 600,
        margin: 25,
        dots: false,
        nav: true,
        navText: [navPrev, navNext],
        slideBy: 1,
        responsive: {
          0: { items: 1 },
          640: { items: 2 },
          1024: { items: 3 },
        },
      });
    });

    // Products slider — 4 columns desktop, advances one slide per
    // scroll/arrow click, autoplay, nav arrows
    fresh('.phent-products-slider').each(function () {
      const $slider = $(this);

      $slider.owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout: parseInt($slider.data('autoplay'), 10) || 7000,
        autoplayHoverPause: true,
        smartSpeed: 600,
        // Same gutter as the categories grid (gap-5 = 1.25rem at the 124% root)
        margin: 25,
        dots: false,
        nav: true,
        navText: [navPrev, navNext],
        slideBy: 1,
        responsive: {
          0: { items: 2 },
          640: { items: 3 },
          1024: { items: 4 },
        },
      });
    });
  }

  // Exposed for the block-editor preview bundle (editor-preview.js).
  window.phentInitSliders = initSliders;

  $(function () {
    initSliders(document);
  });
})(jQuery);
